import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { MatTableDataSource, MatTable } from '@angular/material/table';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { CodeEnforcementService } from '../code-enforcement.service';
import * as moment from 'moment';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';


@Component({
  selector: 'app-expired-case',
  templateUrl: './expired-case.component.html',
  styleUrls: ['./expired-case.component.scss'],
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({ height: '0px', minHeight: '0' })),
      state('expanded', style({ height: '*' })),
      transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
  ],
})
export class ExpiredCaseComponent implements OnInit {
  public caseData = [];
  public isLinear: any;
  public expiredCaseList: any;
  public caseCategoriesList: any;
  public caseList: any;
  public formDialog: MatDialogRef<any> = null;
  public confirmDialog: MatDialogRef<any> = null;
  public categories: any;
  public days: any;
  public status: any;
  public caseIds: any;
  public columnNames = [
    'Case',
    'Date',
    'Violation',
    'User',
    'Street.No',
    'Street',
    'Days',
    'Category',
    'Status',
    'Expiry Date',
    'Expired/Not Expired',
    'timeline'

  ]

  @ViewChild(MatPaginator, { static: false })
  set paginator(value: MatPaginator) {
    if (this.dataSource) {
      this.dataSource.paginator = value;
    }
  }
  @ViewChild(MatSort, { static: false })
  set sort(value: MatSort) {
    if (this.dataSource) {
      this.dataSource.sort = value;
    }
  }
  public tableData;
  public tableColumnsNames;
  public showSpinner: boolean = false;
  searchForm: FormGroup;
  //columnNames;
  dataSource = new MatTableDataSource();
  public expandedElement;
  @ViewChild('formRef') formRef: TemplateRef<any>;
  @ViewChild('confirmRef') confirmRef: TemplateRef<any>;
  @ViewChild('searchFormRef') searchFormRef: TemplateRef<any>;

  constructor(private codeEnforcementService: CodeEnforcementService,
    private formBuilder: FormBuilder, public dialog: MatDialog,) {
    history.pushState(null, null, location.href);
    window.onpopstate = function () {
      history.go(1);
    }
  }

  ngOnInit(): void {
    this.searchForm = this.formBuilder.group({
      case: [''],
      statusId: [''],
      daysToCureId: [''],
      categoryId: [''],
      isExpired: ['']
    });
    console.log('expired...');
    this.codeEnforcementService.fetchAllCategories().subscribe((categoryRes) => {
      this.categories = categoryRes.categoryList.filter(f => f.category != 'Other');;
      this.categories.sort((a, b) => a.category.localeCompare(b.category));
      // this.streets.sort((a, b) => a.street.localeCompare(b.street));
    });

    this.codeEnforcementService.fetchAllDaysToCure().subscribe((daysRes) => {

      this.days = daysRes.DaysToCureList.filter(f => f.numberOfDays != 'Other');;
      // this.otherReasonForDays = this.days.filter(s => s.numberOfDays == 'Other')
      // this.streets.sort((a, b) => a.street.localeCompare(b.street));
    });

    this.codeEnforcementService.fetchStatus().subscribe((statusRes) => {
      this.status = statusRes.statusList;
      // this.otherReasonForDays = this.days.filter(s => s.numberOfDays == 'Other')
      // this.streets.sort((a, b) => a.street.localeCompare(b.street));
      // this.closeStatus = this.status.filter(s => s.status == 'Close')
      // this.openStatus = this.status.filter(s => s.status == 'Open')
    });

    // this.filteredOptions = this.searchForm.controls['case'].valueChanges.pipe(
    //   startWith(''),
    //   map(value => this._filter(value))
    // );

    this.fetchAllCases();
  }

  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }

  fetchAllCases() {
    this.showSpinner = true;
    console.log(this.tableData, 'dataaa');
    if (this.tableData == undefined) {
      this.codeEnforcementService.fetchCaseCategories().subscribe((caseCategoriesRes) => {
        this.caseCategoriesList = caseCategoriesRes.caseCategoriesList;

        // if(caseCategoriesRes.statusList.length){
        //   caseCategoriesRes.statusList.forEach((ele)=>{
        //     caseCategoryArray.push(ele.)
        //   });
        // }
        // this.otherReasonForDays = this.days.filter(s => s.numberOfDays == 'Other')
        // this.streets.sort((a, b) => a.street.localeCompare(b.street));
      });
      this.codeEnforcementService.fetchAllCases(this.searchForm.value).subscribe((res) => {
        console.log(res);
        this.showSpinner = false;
        if (res.casesList.length > 0) {
          let cases = [];
          let categories = [];
          res.casesList.map((data: any) => {
            let caseCategoryArray = [];
            if (this.caseCategoriesList != null) {
              let categories = this.caseCategoriesList.filter(c => c.caseId == data.id)
              categories.forEach((ele) => {
                caseCategoryArray.push({ 'category': ele.category.category, 'date': ele.createdAt });
              })
              console.log(categories, 'categories')
            }
            caseCategoryArray.sort((a, b) => <any>new Date(a.date).getTime() - <any>new Date(b.date).getTime());

            // let firstCaseCategoryArray = [];
            // if(caseCategoryArray.length==0){
            //   firstCaseCategoryArray.push(data.category.category);
            // }else{
            //   firstCaseCategoryArray = [];
            // }
            let statusOpen;
            if (data && data.caseStatus && data.caseStatus.status && data.caseStatus.status == 'Open') {
              if (data.isExpired) {
                statusOpen = 'Expired';
              } else {
                statusOpen = 'NotExpired';
              }
            }
            let caseData = {
              'Case': data.case,
              'Date': moment(data.date).format("DD/MM/YY"),
              'Expiry Date': moment(data.expiryDate).format("DD/MM/YY"),
              'Violation': (data && data.violation) ? data.violation.violation : null,
              'User': (data && data.user) ? data.user.userName : null,
              'Street.No': data.streetNo,
              'Street': (data && data.streets) ? data.streets.street : null,
              'Days': (data && data.daysToCure) ? data.daysToCure.numberOfDays : null,
              'Category': (data && data.category) ? data.category.category : null,
              'Status': (data && data.caseStatus) ? data.caseStatus.status : null,
              'Expired/Not Expired': statusOpen ? statusOpen : '--',
              'viloationHistory': caseCategoryArray ? caseCategoryArray : null
            }
            cases.push(caseData);
            if (this.searchForm.touched) {
              this.confirmDialog.close();
            }
          })
          this.expiredCaseList = cases;
          this.caseIds = this.expiredCaseList.map(c => c.Case);
          if (this.expiredCaseList) {
            this.dataSource.data = this.expiredCaseList.sort((a, b) => <any>new Date(b.Date).getTime() - <any>new Date(a.Date).getTime());
          }
          console.log(this.expiredCaseList, 'list')
          // this.tableRendering();
        } else {
          this.dataSource.data = [];
        }
      });
    }
    if (this.tableData) {
      this.showSpinner = false;
      this.expiredCaseList = this.tableData;
      // this.tableRendering();
      console.log(this.tableData, 'tab')
      this.dataSource.data = this.tableData;
    }
    // if (this.confirmDialog) this.confirmDialog.close();

  }

  private _filter(value: string): string[] {
    const filterValue = value.toLowerCase();
    return this.caseIds.filter(option => option.toLowerCase().indexOf(filterValue) === 0);
  }

  // onSubmitSearch() {
  //   this.showSpinner = true;
  //   if (this.tableData == undefined) {
  //     this.codeEnforcementService.fetchCaseCategories().subscribe((caseCategoriesRes) => {
  //       this.caseCategoriesList = caseCategoriesRes.caseCategoriesList;

  //       // if(caseCategoriesRes.statusList.length){
  //       //   caseCategoriesRes.statusList.forEach((ele)=>{
  //       //     caseCategoryArray.push(ele.)
  //       //   });
  //       // }
  //       // this.otherReasonForDays = this.days.filter(s => s.numberOfDays == 'Other')
  //       // this.streets.sort((a, b) => a.street.localeCompare(b.street));
  //     });
  //     console.log(this.searchForm.value, 'valllll')
  //     this.codeEnforcementService.fetchAllCases(this.searchForm.value).subscribe((res) => {
  //       console.log(res);
  //       this.showSpinner = false;
  //       if (res.casesList.length > 0) {
  //         let cases = [];
  //         let categories = [];
  //         res.casesList.map((data: any) => {
  //           let categories = this.caseCategoriesList.filter(c => c.caseId == data.id)
  //           let caseCategoryArray = [];
  //           categories.forEach((ele) => {
  //             caseCategoryArray.push({ 'category': ele.category.category, 'date': ele.createdAt });
  //           })
  //           caseCategoryArray.sort((a, b) => <any>new Date(a.date).getTime() - <any>new Date(b.date).getTime());

  //           console.log(categories, 'categories')
  //           // let firstCaseCategoryArray = [];
  //           // if(caseCategoryArray.length==0){
  //           //   firstCaseCategoryArray.push(data.category.category);
  //           // }else{
  //           //   firstCaseCategoryArray = [];
  //           // }
  //           let statusOpen;
  //           if (data && data.caseStatus && data.caseStatus.status && data.caseStatus.status == 'Open') {
  //             if (data.isExpired) {
  //               statusOpen = 'Expired';
  //             } else {
  //               statusOpen = 'NotExpired';
  //             }
  //           }
  //           let caseData = {
  //             'Case': data.case,
  //             'Date': moment(data.date).format("DD/MM/YY"),
  //             'Expiry Date': moment(data.expiryDate).format("DD/MM/YY"),
  //             'Violation': (data && data.violation) ? data.violation.violation : null,
  //             'User': (data && data.user) ? data.user.userName : null,
  //             'Street.No': data.streetNo,
  //             'Street': (data && data.streets) ? data.streets.street : null,
  //             'Days': (data && data.daysToCure) ? data.daysToCure.numberOfDays : null,
  //             'Category': (data && data.category) ? data.category.category : null,
  //             'Status': (data && data.caseStatus) ? data.caseStatus.status : null,
  //             'Expired/Not Expired': statusOpen ? statusOpen : '--',
  //             'viloationHistory': caseCategoryArray ? caseCategoryArray : null
  //           }
  //           cases.push(caseData);
  //         })
  //         this.expiredCaseList = cases;
  //         if (this.expiredCaseList) {
  //           this.dataSource.data = this.expiredCaseList.sort((a, b) => <any>new Date(b.Date).getTime() - <any>new Date(a.Date).getTime());
  //         }
  //         console.log(this.expiredCaseList, 'list')
  //         // this.tableRendering();
  //       }
  //     });
  //   }
  //   if (this.tableData) {
  //     this.showSpinner = false;
  //     this.caseList = this.tableData;
  //     // this.tableRendering();
  //     console.log(this.tableData, 'tab')
  //     this.dataSource.data = this.tableData;
  //   }
  //   this.confirmDialog.close();
  // }

  reset() {
    this.searchForm.reset();
    this.fetchAllCases();
  }

  openDialogForSearch() {
    this.confirmDialog = this.dialog.open(this.searchFormRef, {
      width: '550px',
      data: 'data'
    });
  }

}
